// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wl-provinces-cascader[data-v-f94c5988] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n}\n.wl-provinces-cascader .el-cascader[data-v-f94c5988] {\n  width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
